import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import { CodeEditor } from "@pufflig/prompt-studio-ui";
import { useEffect, useState } from "react";
import YAML from "yaml";
import { saveSemanticModel } from "../actions/saveSemanticModel";
import { useSemanticModelStore } from "../state/SemanticModelProvider";
import { useSemanticModel } from "../state/useSemanticModel";

interface EditSchemaYamlModalProps {
  isOpen: boolean;
  onClose: () => void;
  connectorId?: string;
}

export const EditSchemaYamlModal = ({ isOpen, onClose, connectorId }: EditSchemaYamlModalProps) => {
  const semanticModel = useSemanticModel((s) => s.semanticModel);
  const toast = useToast();
  const [editorState, setEditorState] = useState("");

  useEffect(() => {
    if (isOpen) {
      const yaml = semanticModel ? YAML.stringify(semanticModel) : "";
      setEditorState(yaml);
    }
  }, [isOpen, semanticModel]);

  const handleSave = async () => {
    try {
      const parsed = YAML.parse(editorState || "");
      useSemanticModelStore.setState((state) => {
        state.semanticModel = parsed;
      });
      if (connectorId) {
        await saveSemanticModel(connectorId, parsed);
      }
      onClose();
    } catch (error) {
      toast({
        title: "Error",
        description: "Invalid YAML format",
        status: "error",
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent maxW="80%">
        <ModalHeader>
          <Text textStyle="heading/3/medium">Semantic Model YAML</Text>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          <Box height="60vh" borderRadius={"md"} overflow="hidden" border="1px solid" borderColor="border.secondary">
            <CodeEditor language="yaml" code={editorState} onChange={setEditorState} isEditable showLineNumbers />
          </Box>
        </ModalBody>
        <ModalFooter>
          <Stack direction="row" gap="1">
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
